var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElctric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 48,
    viewBox: "0 0 29 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3006 27.3393L12.4713 46.5299C11.0062 48.3061 8.19356 46.6071 9.08404 44.4837L13.3265 34.3676C13.8711 33.069 12.939 31.6293 11.5313 31.5947L2.22825 31.366C0.743593 31.3295 -0.184826 29.7448 0.509293 28.4319L14.9776 1.06523C15.324 0.409945 16.0045 0 16.7457 0H26.0197C27.5425 0 28.5067 1.63418 27.7703 2.96716L17.7526 21.0995C17.0162 22.4325 17.9803 24.0667 19.5032 24.0667H26.7577C28.4487 24.0667 29.3766 26.0348 28.3006 27.3393Z",
    fill: "#4D3ECC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElctric);
export default __webpack_public_path__ + "static/media/elctric.de1c7c4c1f7eede0af6eb08b3406ff2f.svg";
export { ForwardRef as ReactComponent };